'use strict';


var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    method: 'scroll',
  	container: '#AjaxinateContainer',
  	pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.handleScrollPos = this.handleScrollPos.bind(this);
  this.recordPos = this.recordPos.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
  this.handleScrollPos();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
    document.querySelectorAll('#AjaxinateContainer > .grid-item').forEach(function(item){
      item.addEventListener('click', this.recordPos);
    }, this);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = '<svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"><path fill="#000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform></path></svg>';
// 	  $(this.nextPageLinkElement).html('<svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"><path fill="#000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform></path></svg>');
      this.nextPageUrl = this.nextPageLinkElement.href;
      
      var _this = this;
      setTimeout(function(e){
        _this.loadMore();
      },200)
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  var _this = this;
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var page_el = document.querySelector('#AjaxinatePagination');
      var page_el_link = page_el.querySelector('a');
      
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      
      if(page_el_link){
        var updatedUrl = theme.HelperFunc.deleteParamFromURL('page', page_el_link.href);
        var sort_by = theme.HelperFunc.getParamFromURL('sort_by', window.location.href);
        var page = theme.HelperFunc.getParamFromURL('page', page_el_link.href);
        if(sort_by){
          updatedUrl = theme.HelperFunc.setParamInURL('sort_by', sort_by, updatedUrl);
        }
        updatedUrl = theme.HelperFunc.setParamInURL('p', page, updatedUrl);

        history.replaceState('','', updatedUrl);
      }
      

      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
//   console.log(this.nextPageUrl)
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
  document.querySelectorAll('#AjaxinateContainer > .grid-item').forEach(function(item){
    item.removeEventListener('click', this.recordPos);
  }, this);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};

//Ajaxinate.prototype.handleScrollPos=function(){var e=this,n=theme.HelperFunc.getParamFromURL("p");if(n){for(var t=[],r=window.location.pathname;n>1;){var o=r+"?page="+n;t.push(o),n--}0!==t.length&&(t.reverse(),Promise.all(t.map(e=>fetch(e))).then(e=>Promise.all(e.map(e=>e.text()))).then(n=>{if(n.length){n.map(n=>{var t=theme.HelperFunc.stringToHTML(n),r=t.querySelectorAll(e.settings.container)[0],o=t.querySelectorAll(e.settings.pagination)[0];e.containerElement.insertAdjacentHTML("beforeend",r.innerHTML),e.paginationElement.innerHTML=o.innerHTML}),e.initialize();let t=sessionStorage.getItem("scroll");t&&null!==t&&window.scrollTo(0,t)}}).catch(e=>{console.error("Error",e)}))}};
//theme.HelperFunc={setParamInURL:function(e,r,n){n||(n=window.location.href);var t=new URL(n),o=t.searchParams;return o.set(e,r),t.search=o.toString(),t.toString()},getParamFromURL:function(e,r){return r||(r=window.location.href),new URL(r).searchParams.get(e)},deleteParamFromURL:function(e,r){if(!e)return null;r||(r=window.location.href);var n=new URL(r);return n.searchParams.delete(e),n.toString()},stringToHTML:function(e){return e?(new DOMParser).parseFromString(e,"text/html").body:""}},window.addEventListener("beforeunload",()=>{sessionStorage.setItem("scroll",window.pageYOffset)});
Ajaxinate.prototype.handleScrollPos = function() {
    var e = this,
        page = theme.HelperFunc.getParamFromURL("p");
  	var sort_by = theme.HelperFunc.getParamFromURL('sort_by', window.location.href);
    if (page) {
      //console.log('hello');
      	var new_url = theme.HelperFunc.deleteParamFromURL('p', window.location.href);
      	var searchParam = new URL(new_url).search;
        var r = window.location.pathname;
        if(searchParam){
          r += searchParam;
        }
        for (var t = []; page > 1;) {
          var o = r + "?page=" + page;
            if(searchParam){
              var o = r + "&page=" + page;
            }
          	if(sort_by) o += '&sort_by='+ sort_by;
            t.push(o), page--
        }
        0 !== t.length && (t.reverse(), Promise.all(t.map(e => fetch(e))).then(e => Promise.all(e.map(e => e.text()))).then(n => {
          //console.log('hello 2');
            if (n.length) {
              //console.log('hello 3');
                n.map(n => {
                    var t = theme.HelperFunc.stringToHTML(n),
                        r = t.querySelectorAll(e.settings.container)[0],
                        o = t.querySelectorAll(e.settings.pagination)[0];
                    e.containerElement.insertAdjacentHTML("beforeend", r.innerHTML), e.paginationElement.innerHTML = o.innerHTML
                }), e.initialize();
                let t = sessionStorage.getItem("scroll");
                t && null !== t && window.scrollTo(0, t)
            }
        }).catch(e => {
            //console.error("Error", e)
        }))
    }
};

Ajaxinate.prototype.recordPos = function recordPos(){
  sessionStorage.setItem("scroll", window.pageYOffset)
}

theme.HelperFunc = {
    setParamInURL: function(e, r, n) {
        n || (n = window.location.href);
        var t = new URL(n),
            o = t.searchParams;
        return o.set(e, r), t.search = o.toString(), t.toString()
    },
    getParamFromURL: function(e, r) {
        return r || (r = window.location.href), new URL(r).searchParams.get(e)
    },
    deleteParamFromURL: function(e, r) {
        if (!e) return null;
        r || (r = window.location.href);
        var n = new URL(r);
        return n.searchParams.delete(e), n.toString()
    },
    stringToHTML: function(e) {
        return e ? (new DOMParser).parseFromString(e, "text/html").body : ""
    }
}
  
// window.onscroll = function(){
//     //sessionStorage.setItem("scroll", window.pageYOffset)
// }
window.addEventListener("beforeunload", function(){
    sessionStorage.setItem("scroll", window.pageYOffset)
});
